<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" v-bind:href="'#t1'+rowData.peruf_id+''" role="tab" data-toggle="tab">
            <span class="nav-link-in">
              Detalhes
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div role="tabpanel" class="tab-pane fade in active show pt-1 border-color-detalhes-grey" v-bind:id="'t1'+rowData.peruf_id+''">
          <table class="table" id="mais">
            <thead>
            <tr>
              <th style="width: 30%">Ordem</th>
              <th style="width: 30%">UF</th>
              <th style="width: 20%">Status</th>
              <th style="width: 20%">Ações</th>
            </tr>
            </thead>
            <tbody>
            <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.percurso_uf_ordem">
              <td>
                {{ item.ordem}}
              </td>
              <td>
                {{ item.uf.cd}}
              </td>
              <td>
                <span class="badge badge-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                <span class="badge badge-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
              </td>
              <td>
                <a @click="onEditPercursoUfOrdem(item)" v-b-tooltip title="Editar"><i class="fa fa-pencil-square-o"></i></a>
              </td>
            </tr>
            </tbody>
          </table>
        </div><!--.tab-pane-->
      </div><!--.tab-content-->
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      helpForm: new Form({statusRecord: [], params: []}),
    }
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    onEditPercursoUfOrdem(data) {
      this.$parent.$parent.onEditPercursoUfOrdem(data);
    },
  }
}
</script>
